import { Container, Col, Row } from 'react-bootstrap';
import Header from "../../layouts/header";
import FMSLogoImage from "../../Asset/Images/FMSLogoImage.png"
import './maintenancePage.css'
import Footer from '../../layouts/footer/footer';
import React,{useEffect} from "react";
import { useLocation,useNavigate} from "react-router-dom";

function MaintenancePage() {
  const location = useLocation();
  const thankyouRoute =  location.state ? location.state.thankyou : false;


  const navigate = useNavigate();
  const handleEvent = (e) => {
    console.log(" handleEvent back in MaintenancePage")
    navigate("/",{replace:true})
  };

  useEffect(() => {
    window.addEventListener("popstate", handleEvent);
  });

  useEffect(()=>{
    window.history.pushState(null, null, location.href);
    window.onpopstate = function(event) {
     window.history.go(1);
   };
})

  useEffect(() => {
    window.history.pushState(null, document.title, window.location.href);
    window.addEventListener('popstate', function(event) {
      window.history.pushState(null, document.title, window.location.href);
    });
  }, [location]);

    return(
        <>
    <Header disableDropDown={true}/> 
    <Container fluid style={{height : '100%'}} className='container-maintenance-main'>
        <Row>
        <Col xl={3} lg={3} md={2} sm={1} xs={0} xxs={0}>
            <div>
            </div>
        </Col>
        <Col xl={6} lg={6} md={8} sm={10} xs={12} xxs={12} className="subContainer-maintenancePage">
            <Container fluid className="container-maintenaceTitle">
                <Row className="row">
                    <Col xl={12} lg={12} md={12} sm={12} xs={12} xxs={12}>
                        <div> <p className='maintenancePage-title-text'>Inlichtingen – Information</p> </div>
                    </Col>
                </Row>
            </Container>
           
            <Container fluid className="container-maintenacelogo">
            <Row className="row">
            <Col xl={12} lg={12} md={12} sm={12} xs={12} xxs={12}>
                    <img className="image-maintaenanceLogo" src={FMSLogoImage} alt="FMS Logo" role="presentation" />
                </Col>
            </Row>
            </Container>
            <Container fluid className='container-maintenancePara'>
                <Row className="row">
                    <Col xl={12} lg={12} md={12} sm={12} xs={12} xxs={12}>
                        <div className="div-error-text">
                        {!thankyouRoute && <p className="text-paras-maintenancePage">Welkom bij FixMyStation! Bedankt dat je de URL-link van onze app gebruikte.
 Wil je een technisch incident melden? Scan dan rechtstreeks de QR-code.
 Het team FixMystation</p>}

 {!thankyouRoute && <p className="text-paras-maintenancePage">Bienvenue dans FixMyStation ! Nous vous remercions d’avoir utilisé le lien URL de notre application.
Merci de scanner directement le code QR pour signaler un incident technique.
L’équipe FixMyStation</p> }
                                
{!thankyouRoute && <p className="text-paras-maintenancePage">Willkommen bei der App FixMyStation! Wir danken Ihnen, dass Sie den URL-Link unserer App verwendet haben.
Bitte scannen Sie den QR-Code, um eine technische Störung zu melden.
Das FixMyStation-Team</p> }

{!thankyouRoute && <p className="text-paras-maintenancePage">Welcome to FixMyStation! Thank you for using our application’s URL link.
Please scan the QR code to report a technical incident.
The FixMyStation team</p> }

{thankyouRoute && <p className="text-paras-maintenancePage">Dank u voor het gebruik van onze applicatie-URL-link.
Scan de QR-code om een technisch incident te melden.
Het FixMyStation-team</p> }
{thankyouRoute && <p className="text-paras-maintenancePage">Merci d'utiliser le lien URL de notre application.
Veuillez scanner le code QR pour signaler un incident technique.
L'équipe FixMyStation</p> }
{thankyouRoute && <p className="text-paras-maintenancePage">Danke, dass Sie den URL-Link unserer Anwendung verwenden.
Bitte scannen Sie den QR-Code, um einen technischen Vorfall zu melden.
Das FixMyStation-Team</p> }
{thankyouRoute && <p className="text-paras-maintenancePage">Thank you for using our application’s URL link.
Please scan the QR code to report a technical incident.
The FixMyStation team</p> }
                        </div>
                    </Col>
                </Row>
                </Container>
                </Col>
                <Col xl={3} lg={3} md={2} sm={1} xs={0} xxs={0}>
                    <div>
                    </div>
                </Col>
                </Row>
                <Footer />
        </Container>
        </>
    );
}

export default MaintenancePage;